//User Data Update Members
export const UPDATE_USER_MEMBERS_REQUEST = 'UPDATE_USER_MEMBERS_REQUEST'
export const UPDATE_USER_MEMBERS_FAILURE = 'UPDATE_USER_MEMBERS_FAILURE'
export const UPDATE_USER_MEMBERS_SUCCESS = 'UPDATE_USER_MEMBERS_SUCCESS'
//User Password Update Members
export const UPDATE_PASSWORD_MEMBERS_REQUEST = 'UPDATE_PASSWORD_MEMBERS_REQUEST'
export const UPDATE_PASSWORD_MEMBERS_FAILURE = 'UPDATE_PASSWORD_MEMBERS_FAILURE'
export const UPDATE_PASSWORD_MEMBERS_SUCCESS = 'UPDATE_PASSWORD_MEMBERS_SUCCESS'
//SignUp Members
export const SIGNUP_MEMBERS_REQUEST = 'SIGNUP_MEMBERS_REQUEST'
export const SIGNUP_MEMBERS_FAILURE = 'SIGNUP_MEMBERS_FAILURE'
export const SIGNUP_MEMBERS_SUCCESS = 'SIGNUP_MEMBERS_SUCCESS'
//SignUp Members Resend Email
export const RESEND_EMAIL_MEMBERS_REQUEST = 'RESEND_EMAIL_MEMBERS_REQUEST'
export const RESEND_EMAIL_MEMBERS_FAILURE = 'RESEND_EMAIL_MEMBERS_FAILURE'
export const RESEND_EMAIL_MEMBERS_SUCCESS = 'RESEND_EMAIL_MEMBERS_SUCCESS'
//SignIn Membres
export const SIGNIN_MEMBERS_REQUEST = 'SIGNIN_MEMBERS_REQUEST'
export const SIGNIN_MEMBERS_FAILURE = 'SIGNIN_MEMBERS_FAILURE'
export const SIGNIN_MEMBERS_SUCCESS = 'SIGNIN_MEMBERS_SUCCESS'
//SignIn Courtiers
export const SIGNIN_COURTIERS_REQUEST = 'SIGNIN_COURTIERS_REQUEST'
export const SIGNIN_COURTIERS_FAILURE = 'SIGNIN_COURTIERS_FAILURE'
export const SIGNIN_COURTIERS_SUCCESS = 'SIGNIN_COURTIERS_SUCCESS'
//SignIn Membres Verified Email
export const VERIFIED_EMAIL_MEMBERS_REQUEST = 'VERIFIED_EMAIL_MEMBERS_REQUEST'
export const VERIFIED_EMAIL_MEMBERS_FAILURE = 'VERIFIED_EMAIL_MEMBERS_FAILURE'
export const VERIFIED_EMAIL_MEMBERS_SUCCESS = 'VERIFIED_EMAIL_MEMBERS_SUCCESS'
//SignIn Membres Expire Token (A revoir)
export const TOKEN_EXPIRE_MEMBERS_REQUEST = 'TOKEN_EXPIRE_MEMBERS_REQUEST'
export const TOKEN_EXPIRE_MEMBERS_FAILURE = 'TOKEN_EXPIRE_MEMBERS_FAILURE'
export const TOKEN_EXPIRE_MEMBERS_SUCCESS = 'TOKEN_EXPIRE_MEMBERS_SUCCESS'
//SignIn Membres Reauthentificate
export const REAUTHENTIFICATE_MEMBERS_REQUEST = 'REAUTHENTIFICATE_MEMBERS_REQUEST'
export const REAUTHENTIFICATE_MEMBERS_FAILURE = 'REAUTHENTIFICATE_MEMBERS_FAILURE'
export const REAUTHENTIFICATE_MEMBERS_SUCCESS = 'REAUTHENTIFICATE_MEMBERS_SUCCESS'
//SignIn Courtiers Reauthentificate
export const REAUTHENTIFICATE_COURTIERS_REQUEST = 'REAUTHENTIFICATE_COURTIERS_REQUEST'
export const REAUTHENTIFICATE_COURTIERS_FAILURE = 'REAUTHENTIFICATE_COURTIERS_FAILURE'
export const REAUTHENTIFICATE_COURTIERS_SUCCESS = 'REAUTHENTIFICATE_COURTIERS_SUCCESS'
//Souscripteur
export const SOUSCRIPTEUR_REQUEST = 'SOUSCRIPTEUR_REQUEST'
export const SOUSCRIPTEUR_FAILURE = 'SOUSCRIPTEUR_FAILURE'
export const SOUSCRIPTEUR_SUCCESS = 'SOUSCRIPTEUR_SUCCESS'
// Add Souscripteur
export const ADD_SOUSCRIPTEUR_REQUEST = 'ADD_SOUSCRIPTEUR_REQUEST'
export const ADD_SOUSCRIPTEUR_FAILURE = 'ADD_SOUSCRIPTEUR_FAILURE'
export const ADD_SOUSCRIPTEUR_SUCCESS = 'ADD_SOUSCRIPTEUR_SUCCESS'
// Update Souscripteur
export const UPDATE_SOUSCRIPTEUR_REQUEST = 'UPDATE_SOUSCRIPTEUR_REQUEST'
export const UPDATE_SOUSCRIPTEUR_FAILURE = 'UPDATE_SOUSCRIPTEUR_FAILURE'
export const UPDATE_SOUSCRIPTEUR_SUCCESS = 'UPDATE_SOUSCRIPTEUR_SUCCESS'
//Beneficiaires
export const BENEFICIAIRE_REQUEST = 'BENEFICIAIRE_REQUEST'
export const BENEFICIAIRE_FAILURE = 'BENEFICIAIRE_FAILURE'
export const BENEFICIAIRE_SUCCESS = 'BENEFICIAIRE_SUCCESS'
//Remove Beneficiaire
export const REMOVE_BENEFICIAIRE_REQUEST = 'REMOVE_BENEFICIAIRE_REQUEST'
export const REMOVE_BENEFICIAIRE_FAILURE = 'REMOVE_BENEFICIAIRE_FAILURE'
export const REMOVE_BENEFICIAIRE_SUCCESS = 'REMOVE_BENEFICIAIRE_SUCCESS'
//Create Beneficiaire
export const ADD_BENEFICIAIRE_REQUEST = 'ADD_BENEFICIAIRE_REQUEST'
export const ADD_BENEFICIAIRE_FAILURE = 'ADD_BENEFICIAIRE_FAILURE'
export const ADD_BENEFICIAIRE_SUCCESS = 'ADD_BENEFICIAIRE_SUCCESS'
//Update Beneficiaire
export const UPDATE_BENEFICIAIRE_REQUEST = 'UPDATE_BENEFICIAIRE_REQUEST'
export const UPDATE_BENEFICIAIRE_FAILURE = 'UPDATE_BENEFICIAIRE_FAILURE'
export const UPDATE_BENEFICIAIRE_SUCCESS = 'UPDATE_BENEFICIAIRE_SUCCESS'
//Parrain
//GET ALL CLICKS
export const ALL_CLICKS_REQUEST = 'ALL_CLICKS_REQUEST'
export const ALL_CLICKS_FAILURE = 'ALL_CLICKS_FAILURE'
export const ALL_CLICKS_SUCCESS = 'ALL_CLICKS_SUCCESS'
//GET ALL Souscription
export const ALL_SOUSCRIPTIONS_REQUEST = 'ALL_SOUSCRIPTIONS_REQUEST'
export const ALL_SOUSCRIPTIONS_FAILURE = 'ALL_SOUSCRIPTIONS_FAILURE'
export const ALL_SOUSCRIPTIONS_SUCCESS = 'ALL_SOUSCRIPTIONS_SUCCESS'
//GET WEEK Souscription
export const WEEK_SOUSCRIPTIONS_REQUEST = 'WEEK_SOUSCRIPTIONS_REQUEST'
export const WEEK_SOUSCRIPTIONS_FAILURE = 'WEEK_SOUSCRIPTIONS_FAILURE'
export const WEEK_SOUSCRIPTIONS_SUCCESS = 'WEEK_SOUSCRIPTIONS_SUCCESS'
//GET WEEK Souscription
export const ACTIVATED_POLICIES_REQUEST = 'ACTIVATED_POLICIES_REQUEST'
export const ACTIVATED_POLICIES_FAILURE = 'ACTIVATED_POLICIES_FAILURE'
export const ACTIVATED_POLICIES_SUCCESS = 'ACTIVATED_POLICIES_SUCCESS'
//Questionnaire
export const ADD_QUESTIONNAIRE_REQUEST = 'ADD_QUESTIONNAIRE_REQUEST'
export const ADD_QUESTIONNAIRE_FAILURE = 'ADD_QUESTIONNAIRE_FAILURE'
export const ADD_QUESTIONNAIRE_SUCCESS = 'ADD_QUESTIONNAIRE_SUCCESS'
//Upload Photo
export const ADD_UPLOAD_IMAGE_REQUEST = 'ADD_UPLOAD_IMAGE_REQUEST'
export const ADD_UPLOAD_IMAGE_FAILURE = 'ADD_UPLOAD_IMAGE_FAILURE'
export const ADD_UPLOAD_IMAGE_SUCCESS = 'ADD_UPLOAD_IMAGE_SUCCESS'
//Get Image
export const GET_UPLOAD_IMAGE_REQUEST = 'GET_UPLOAD_IMAGE_REQUEST'
export const GET_UPLOAD_IMAGE_FAILURE = 'GET_UPLOAD_IMAGE_FAILURE'
export const GET_UPLOAD_IMAGE_SUCCESS = 'GET_UPLOAD_IMAGE_SUCCESS'
//Logout
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
//Send Mail to souscripetur after submetted
export const SEND_MAIL_SOUSCRIPTEUR_REQUEST = 'SEND_MAIL_SOUSCRIPTEUR_REQUEST'
export const SEND_MAIL_SOUSCRIPTEUR_FAILURE = 'SEND_MAIL_SOUSCRIPTEUR_FAILURE'
export const SEND_MAIL_SOUSCRIPTEUR_SUCCESS = 'SEND_MAIL_SOUSCRIPTEUR_SUCCESS'
//Download logo courtier
export const DOWNLOAD_LOGO_COURTIER_REQUEST = 'DOWNLOAD_LOGO_COURTIER_REQUEST'
export const DOWNLOAD_LOGO_COURTIER_FAILURE = 'DOWNLOAD_LOGO_COURTIER_FAILURE'
export const DOWNLOAD_LOGO_COURTIER_SUCCESS = 'DOWNLOAD_LOGO_COURTIER_SUCCESS'



// WEBPACK FOOTER //
// ./src/actions/actionsTypesMembers.js